
import {Vue, Component, Prop} from 'vue-property-decorator';
import ProjectSheets from '../../views/Chart/Modals/ProjectReport.vue'

@Component
export default class ProjectTableFilter extends ProjectSheets {
    
}
